import getColumnType from "./getColumnType";
import isValidCellValue from "./isValidCellValue";

// "Required" on a matrix field means every cell in every row is filled in, and
// each one is valid for its own column type.
//
// An empty grid (no rows or no columns) has nothing to fill in, so it counts as
// complete — otherwise a required matrix the admin has not finished building
// would block the form from ever being submitted.
const isMatrixComplete = (rows, columns, cells) => {
    const allRows = rows || [];
    const allColumns = columns || [];
    const allCells = cells || [];

    return allRows.every((row) =>
        allColumns.every((column) => {
            const cell = allCells.find(
                (c) => c.RowID === row.ID && c.ColumnID === column.ID
            );
            return isValidCellValue(cell?.Value, getColumnType(column));
        })
    );
};

export default isMatrixComplete;
